import WorkbookInterpretationWorkspace from "./WorkbookInterpretationWorkspace";

export default WorkbookInterpretationWorkspace;
